<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="6 " md="5">
                    <h5 class="mt-2">{{Title}}</h5>
                  </b-col>
                  <b-col lg="6" md="7">
                    <catalog-search
                      showButtonText="View Filters"
                      placeholder="Search Advices"
                      hideButtonText="Hide Filters"
                      v-on:show-cat="contentShow"
                      @value="getValue"
                      :isSearch="false"
                      :btnDisabled="checkBtnDisabled"
                      :searchDisabled="searchDisabled"
                    />
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section v-show="isContentShow" class="fadein">
        <b-container fluid>
          <div class="customer-info table-dark-bg box-shadow mt-2 mb-2 p-4 bg-white">
            <b-row>
              <b-col lg="3" class="text-left">
                <label for class="mb-0">Filter by Date</label>
                <b-form-select v-model="requestFilter.date" @change="filterData($event, 0)">
                  <option value>Anytime</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="last_7days">Last 7 Days</option>
                  <option value="last_month">Last 30 Days</option>
                  <option value="custom_range">Custom Range</option>
                </b-form-select>

                <!-- Select date range popup-->
                <b-modal ref="custom-range" hide-footer centered title="Select Date Range">
                  <div class="d-block">
                    <b-row>
                      <b-col>
                        <label for>Start Date</label>
                        <datepicker
                          placeholder="Select Date"
                          input-class="form-control"
                          v-model="startDate"
                        ></datepicker>
                      </b-col>
                      <b-col>
                        <label for>End Date</label>
                        <datepicker
                          placeholder="Select Date"
                          input-class="form-control"
                          v-model="endDate"
                        ></datepicker>
                      </b-col>
                    </b-row>
                  </div>

                  <b-button
                    class="btn grey-btn float-right px-4 mt-4"
                    :disabled="endDate==''"
                    @click="filterData($event, 0)"
                  >
                    <span v-if="$loading == false">Apply Filter</span>
                    <b-spinner small v-if="$loading == true"></b-spinner>
                  </b-button>
                </b-modal>
              </b-col>
              <b-col lg="3" class="text-left">
                <label for class="mb-0">Filter by Status</label>
                <b-form-select v-model="requestFilter.status" @change="filterData($event, 2)">
                  <option value>Nothing Selected</option>
                  <option
                    v-for="status in filter.status"
                    :value="status"
                    v-text="status"
                    :key="status"
                  ></option>
                </b-form-select>
              </b-col>
              <b-col lg="3" class="text-left">
                <label for class="mb-0">Filter by Supplier</label>
                <v-select
                  :options="supplierList"
                  v-model="requestFilter.supplier"
                  class="custom-vselect-small"
                  :searchable="true"
                />
              </b-col>
              <b-col lg="3" class="text-left">
                <label for class="mb-0">Sort by</label>
                <b-form-select v-model="requestFilter.sort" @change="filterData($event,3)">
                  <option value>Nothing Selected</option>
                  <option
                    v-for="sort in filter.sort"
                    :value="sort.key"
                    v-text="sort.name"
                    :key="sort.key"
                  ></option>
                </b-form-select>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div v-bar>
            <div>
              <div class="customer-info table-dark-bg box-shadow p-2 mt-2 customer-info-data">
                <div
                  class="pill p-3 box-shadow mb-2 fade-in"
                  v-for="item in adviceList"
                  :key="item.id"
                  :class="{
                            'partial':(item.status=='PARTIAL'),
                            'pending':(item.status=='PENDING'), 
                            'complete':(item.status=='COMPLETE'), 
                             }"
                >
                  <b-row class="align-items-center">
                    <div class="text-left pl-4 w-15">
                      <h6 class="mb-0 fw-normal">{{item.status}}</h6>
                      <p>{{item.advice_created_date}}</p>
                    </div>
                    <div class="text-left w-15">
                      <label for class="mb-0">Advice Number</label>
                      <p>{{item.advice_no}}</p>
                    </div>
                    <div class="text-left w-15">
                      <label for class="mb-0">Advice Date</label>
                      <p>{{item.created_at}}</p>
                    </div>
                    <div class="text-left w-15">
                      <label for class="mb-0">Supplier</label>
                      <p>{{item.supplier_name}}</p>
                    </div>
                    <div class="text-left w-12" style="width:12%">
                      <label for class="mb-0">Place of Origin</label>
                      <p>{{item.origin_from}}</p>
                    </div>
                    <div class="text-right w-25">
                      <b-btn
                        class="btn-theme mr-0"
                        title="Create GRN"
                        @click="createGrn(item.id)"
                        v-if="item.status == 'PENDING' || item.status == 'PARTIAL'"
                      >
                        <span v-if="$loading == false">Create GRN</span>
                        <b-spinner small v-if="$loading == true"></b-spinner>
                      </b-btn>

                      <b-btn
                        class="btn-theme"
                        title="View Details"
                        v-if="item.status == 'PARTIAL' || item.status == 'COMPLETE'"
                        @click="viewDetails(item.id)"
                      >View Details</b-btn>
                    </div>
                  </b-row>
                </div>

                <div
                  v-if="adviceList.length == 0 && $loading == false"
                  class="d-flex align-items-center justify-content-center"
                  style="height:100%"
                >
                  <h5 class="fw-normal" style>No advices avaliable</h5>
                </div>
              </div>
            </div>
          </div>
        </b-container>
      </section>
    </template>
  </dashboard>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import VSelect from "@alfsnd/vue-bootstrap-select";
import Dashboard from "../views/Dashboard";
import CatalogSearch from "../components/CatalogSearch";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "advicelist",
  components: {
    Dashboard,
    CatalogSearch,
    VSelect,
    Loading,
    Datepicker
  },
  mounted() {
    this.fetchGRN();
  },
  computed: {
    ...mapState({
      state: state => state,
      customerData() {
        return this.$store.getters["sessions/getCustomerParam"]
      },
      supplierList() {
        let data = [];
        data.push({ value: "", text: "Nothing Selected" });
        this.filter.supplier.map(item => {
          data.push({ value: item.id, text: item.name });
        });
        return data;
      }
      /* changeStartDate() {
        let startdate = this.$moment(this.startDate).format("YYYY-MM-DD");
        let finalstartday = startdate;
        return finalstartday;
      },
      changeEndDate() {
        let enddate = this.$moment(this.endDate).format("YYYY-MM-DD");
        let finalendday = enddate;
        return finalendday;
      }*/
    }),
    adviceList() {
      let result = this.GRNList.filter(item => {
        if (item.grn == null) {
          item.grn = "";
        }
        return item;
      });
      if (!this.search) {
        return result;
      }

      const filterValue = this.search.toLowerCase();

      const filter = event =>
        event.advice_no.toLowerCase().includes(filterValue) ||
        event.origin_from.toLowerCase().includes(filterValue) ||
        event.supplier_name.toLowerCase().includes(filterValue);

      return result.filter(filter);
    },
    checkBtnDisabled() {
      if (this.GRNList == "") {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    "requestFilter.supplier": {
      handler(oldValue, newValue) {
        this.filterData(this.requestFilter.supplier.value, 1);
      }
    },
    "requestFilter.sort": {
      handler(oldValue, newValue) {
        this.filterData(this.requestFilter.sort.value, 3);
      }
    },
    deep: true
  },
  data() {
    return {
      Title: "Advices",
      selected: null,
      loading: true,
      searchableName: true,
      isContentShow: false,
      search: "",
      startDate: "",
      fstartDay: "",
      fendDay: "",
      endDate: "",
      GRNList: [],
      filter: {
        status: [],
        supplier: [],
        sort: []
      },
      requestFilter: {
        date: "",
        status: "",
        supplier: "",
        sort: "",
        filter_format: []
      },
      searchDisabled: false
    };
  },

  methods: {
    contentShow(content) {
      this.isContentShow = content;
    },
    fetchGRN: function() {
      this.$loading = true;
      this.searchDisabled = true;
      var data = {
        c_id: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.vu_id,
        trans_from: this.state.system.trans_from,
        terminal_id: this.state.system.settings.terminal_id,
        url:"/vendor/advice-list"
      };
      axios
        .post(data.url, data)
        .then(response => {
          this.GRNList = response.data.data;
          this.filter.status = response.data.filter.status;
          this.filter.supplier = response.data.filter.supplier;
          this.filter.sort = response.data.filter.sort;
          this.requestFilter.filter_format = response.data.filter.filter_format;
          this.$loading = false;
          this.searchDisabled = false;
        })
        .catch(err => {
          this.$loading = false;
          this.searchDisabled = false;
        });
    },
    createGrn(data) {
      this.$router.push("/generate-grn/" + data);
    },
    filterData(event, num) {
      this.$loading = true;
      if (num != 0) {
        this.requestFilter.filter_format[num].value = event;
      } else {
        if (this.requestFilter.date == "") {
          this.requestFilter.filter_format[num].start_date = "";
          this.requestFilter.filter_format[num].end_date = "";
        } else if (this.requestFilter.date == "today") {
          let today = this.$moment().format("YYYY-MM-DD");
          this.requestFilter.filter_format[num].start_date = today;
          this.requestFilter.filter_format[num].end_date = today;
        } else if (this.requestFilter.date == "yesterday") {
          let today = this.$moment().format("YYYY-MM-DD");
          let yesterday = this.$moment()
            .subtract(1, "day")
            .format("YYYY-MM-DD");
          this.requestFilter.filter_format[num].start_date = yesterday;
          this.requestFilter.filter_format[num].end_date = today;
        } else if (this.requestFilter.date == "last_7days") {
          let today = this.$moment().format("YYYY-MM-DD");
          let lastsevendays = this.$moment()
            .subtract(7, "days")
            .format("YYYY-MM-DD");
          this.requestFilter.filter_format[num].start_date = lastsevendays;
          this.requestFilter.filter_format[num].end_date = today;
        } else if (this.requestFilter.date == "last_month") {
          let today = this.$moment().format("YYYY-MM-DD");
          let lastmonth = this.$moment()
            .subtract(1, "month")
            .format("YYYY-MM-DD");
          this.requestFilter.filter_format[num].start_date = lastmonth;
          this.requestFilter.filter_format[num].end_date = today;
        } else if (this.requestFilter.date == "custom_range") {
          this.$refs["custom-range"].show();
          if (this.endDate != "") {
            let startdate = this.$moment(this.startDate).format("YYYY-MM-DD");
            let finalstartday = startdate;
            let enddate = this.$moment(this.endDate).format("YYYY-MM-DD");
            let finalendday = enddate;
            this.requestFilter.filter_format[num].start_date = finalstartday;
            this.requestFilter.filter_format[num].end_date = finalendday;
            this.startDate = "";
            this.endDate = "";
            this.$refs["custom-range"].hide();
          }
        }
      }

      var data = {
        c_id: "",
        api_token: this.state.sessions.user.api_token,
        v_id: this.state.sessions.user.v_id,
        store_id: this.state.sessions.user.store_id,
        vu_id: this.state.sessions.user.user.id,
        trans_from: this.state.system.trans_from,
        filter: JSON.stringify(this.requestFilter.filter_format),
        url:"/vendor/advice-list"
      };
      axios
        .post(data.url, data)
        .then(response => {
          this.GRNList = response.data.data;
          this.filter.status = response.data.filter.status;
          this.filter.supplier = response.data.filter.supplier;
          this.filter.sort = response.data.filter.sort;
          // this.requestFilter.filter_format = response.data.filter.filter_format;
          this.$loading = false;
        })
        .catch(err => {
          this.$loading = false;
        });
    },
    getValue(value) {
      this.search = value;
    },
    clearSearch() {
      this.search = "";
    },
    viewDetails(id) {
      this.$router.push("/advice-details/" + id);
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-select {
  font-size: 13px;
}
.theme-light .customer-info-data {
  background: $grey-btn-bg;
  height: calc(100vh - 69px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}

.theme-dark .customer-info-data {
  background: #202020 !important;
  height: calc(100vh - 69px);
  overflow-x: hidden;
  overflow-y: auto;
  @include custom-scrollbar();
}
h5 {
  color: $grey-color;
}
.pill {
  border-radius: 5px;
  position: relative;
  &:before {
    width: 7px;
    height: 100%;
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
}
h4 {
  color: $mid-grey;
}
.complete h6 {
  color: $success-btn;
}
.partial h6 {
  color: #c0c0c0;
}
.pending h6 {
  color: $danger-btn;
}

.pending.pill {
  &:before {
    background: $danger-btn;
  }
}
.partial.pill {
  &:before {
    background: $dark-card-text;
  }
}
.complete.pill {
  &:before {
    background: $success-btn;
  }
}
.advice .customer-info-data {
  background: #202020 !important;
}
.customer-info-data button {
  margin-right: 5px !important;
}
.theme-light .customer-info {
  background: #e0e0e0;
}
.customer-info .v-select .v-dropdown-container .v-dropdown-item {
  padding: 0.25rem 1.25rem !important;
}
</style>